import { render } from "./PatreonSupportBanner.vue?vue&type=template&id=74f6f4cd&scoped=true"
import script from "./PatreonSupportBanner.vue?vue&type=script&lang=js"
export * from "./PatreonSupportBanner.vue?vue&type=script&lang=js"

import "./PatreonSupportBanner.vue?vue&type=style&index=0&id=74f6f4cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f6f4cd"]])

export default __exports__